import { create } from 'zustand';

interface User {
  id: string;
  email: string;
  username: string;
  displayName: string;
  iconUrl?: string;
  token?: string;
  phoneNumber?: string;
  phoneNumberVerified: boolean;
  accountType: number;
  accountStatus: string; // 'active', 'under_review', 'suspended', etc.
  accountCategory: number;
  emailVerified: boolean;
}

interface UserState {
  user: User | null;
  isLoggedIn: boolean;
  isInitialized: boolean;
  setUser: (user: User | null) => void;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  setInitialized: (isInitialized: boolean) => void;
  logout: () => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  isLoggedIn: false,
  isInitialized: false,
  setUser: (user) => set({ user, isLoggedIn: !!user }),
  setIsLoggedIn: (isLoggedIn) => set({ isLoggedIn }),
  setInitialized: (isInitialized) => set({ isInitialized }),
  logout: () => set({ user: null, isLoggedIn: false }),
}));
